import useApi, { ApiOptions } from '../base/useApi';
import ProductionCompanyDTO from '@src/adapters/dto/productionCompany/ProductionCompanyDTO';

interface Params {
  pageSize: number;
  currentPage: number;
}

interface Result {
  productionCompanies: ProductionCompanyDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/production_company',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProductionCompaniesLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProductionCompaniesLazy;
